module.exports = __webpack_public_path__ + "21f385d1c90452e35d21436a60b29c07.svg";